export const PLATFORM_TOUR_PREFERENCE_KEY = "platform_tour" as const;

export const PLATFORM_TOUR_STATUS = {
  NOT_STARTED: "NOT_STARTED",
  IN_PROGRESS: "IN_PROGRESS",
  SKIPPED: "SKIPPED",
  COMPLETED: "COMPLETED",
} as const;

export type PlatformTourStatus =
  (typeof PLATFORM_TOUR_STATUS)[keyof typeof PLATFORM_TOUR_STATUS];

export const PLATFORM_TOUR_WIDGET_DAYS = 30;

export const PLATFORM_TOUR_SOURCE = {
  WELCOME_MODAL: "welcome_modal",
  WIDGET: "widget",
  GET_HELP: "get_help",
  NEED_HELP: "need_help",
} as const;

export type PlatformTourSource =
  (typeof PLATFORM_TOUR_SOURCE)[keyof typeof PLATFORM_TOUR_SOURCE];

export const PLATFORM_TOUR_VIDEO_URL =
  "https://inkle-django-files-prod.s3.ap-south-1.amazonaws.com/Product+Videos/inkle_product_tour.mp4";

export const PLATFORM_TOUR_PATHS = ["/tax", "/tax/", "/v2/filings-dashboard"];

export const PLATFORM_TOUR_LAYOUT_ID = {
  MEDIA: "platform-tour-media",
} as const;

export const PLATFORM_TOUR_LAYOUT_DURATION_S = 0.7;

export const PLATFORM_TOUR_LAYOUT_TRANSITION = {
  duration: PLATFORM_TOUR_LAYOUT_DURATION_S,
  ease: [0.65, 0, 0.35, 1],
} as const;
